module.exports = __webpack_public_path__ + "static/media/tarja-linhas-dermoglam.5b2a7793.jpg";